import SettingsPermissionsContainer from './containers/SettingsPermissionsContainer';

export default SettingsPermissionsContainer;
